var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1673 18.8327C5.56494 18.8327 1.83398 15.1017 1.83398 10.4993C1.83398 5.89697 5.56494 2.16602 10.1673 2.16602C14.7697 2.16602 18.5007 5.89697 18.5007 10.4993C18.5007 15.1017 14.7697 18.8327 10.1673 18.8327ZM10.1673 17.166C13.8492 17.166 16.834 14.1813 16.834 10.4993C16.834 6.81745 13.8492 3.83268 10.1673 3.83268C6.48542 3.83268 3.50065 6.81745 3.50065 10.4993C3.50065 14.1813 6.48542 17.166 10.1673 17.166Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41732 7.49935C8.10768 7.49935 8.66732 8.05902 8.66732 8.74935C8.66732 9.43968 8.10768 9.99935 7.41732 9.99935C6.72696 9.99935 6.16732 9.43968 6.16732 8.74935C6.16732 8.05902 6.72696 7.49935 7.41732 7.49935ZM13.2507 7.49935C13.941 7.49935 14.5007 8.05902 14.5007 8.74935C14.5007 9.43968 13.941 9.99935 13.2507 9.99935C12.5603 9.99935 12.0007 9.43968 12.0007 8.74935C12.0007 8.05902 12.5603 7.49935 13.2507 7.49935Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4178 12.3824C12.6556 13.2204 11.5566 13.7464 10.3346 13.7464C9.11256 13.7464 8.01346 13.2204 7.2513 12.3824L8.03878 11.6663C8.69706 11.9277 9.48623 12.0798 10.3346 12.0798C11.1829 12.0798 11.9721 11.9277 12.6303 11.6663L13.4178 12.3824Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.76b199be2bc642a41c8d9e31bb713ef7.svg";
export { ForwardRef as ReactComponent };